/* TCH Service — v8 */
document.addEventListener('DOMContentLoaded',function(){
  if(!document.documentElement.classList.contains('tchx-home'))return;
  var EN=window.TCHX_EN||{};
  EN['Votre devis est validé ?']='Has your quote been approved?';
  EN['Réglez-le en ligne, en 1 fois ou en 4 fois sans frais.']='Pay it online, in one go or in 4 interest-free instalments.';
  EN['Devis déjà validé ?']='Quote already approved?';
  var T=function(n){if(window.tchxTranslate)window.tchxTranslate(n);};

  /* Séparateur juste au-dessus de « Pour aller plus loin » */
  function sepMore(){
    var m=document.getElementById('tchxMore');if(!m||!m.parentNode)return;
    var p=m.previousElementSibling;
    if(p&&p.classList.contains('tchx-sep-more'))return;
    if(p&&p.classList.contains('tchx-sep'))p.remove();
    var s=document.createElement('div');s.className='tchx-sep tchx-sep-more';s.setAttribute('aria-hidden','true');s.innerHTML='<span></span><i></i><span></span>';
    m.parentNode.insertBefore(s,m);
  }
  sepMore();setTimeout(sepMore,300);window.addEventListener('load',sepMore);
  new MutationObserver(function(){setTimeout(sepMore,200);}).observe(document.documentElement,{attributes:true,attributeFilter:['data-theme']});

  /* Bandeau « Payer mon devis » juste après le devis */
  var dv=document.getElementById('devis');
  if(dv&&!document.querySelector('.tchx-paybar')){
    var b=document.createElement('section');b.className='tchx-paybar';
    b.innerHTML='<div class="wrap"><div class="t"><span class="ic"><svg viewBox="0 0 24 24" aria-hidden="true"><rect x="2" y="6" width="20" height="13" rx="2"/><path d="M2 10h20M6 15h4"/></svg></span><div><b>Votre devis est validé ?</b><span class="s">Réglez-le en ligne, en 1 fois ou en 4 fois sans frais.</span></div></div><a class="btn btn-primary" href="/pages/payer-mon-devis">Payer mon devis</a></div>';
    dv.parentNode.insertBefore(b,dv.nextSibling);T(b);
  }

  /* Lien discret dans le premier visuel */
  var cta=document.querySelector('.hero .hero-cta');
  if(cta&&!document.querySelector('.tchx-herpay')){
    var h=document.createElement('p');h.className='tchx-herpay';h.innerHTML='<span>Devis déjà validé ?</span> <a href="/pages/payer-mon-devis">Payer mon devis</a>';
    cta.parentNode.insertBefore(h,cta.nextSibling);T(h);
  }
});
